export const ENTER_KEY_CODE = 13;



// WEBPACK FOOTER //
// ./src/apps/phone_verification/util/consts.js